<template>
  <v-dialog
    :data-testid="modalTestID"
    :max-width="maxWidth || 380"
    :persistent="persistent"
    :value="show"
    @click:outside="$emit('close')"
  >
    <v-card class="px-6 py-4 confirmation-dialog">
      <v-card-title style="word-break: break-word" class="ma-0 pa-0 mb-3">
        <p class="ma-0 pa-0 blue-grey--text text--darken-4 h6">
          {{ titleText }}
        </p>
      </v-card-title>

      <v-card-text class="ma-0 pa-0 mb-3">
        <p
          class="ma-0 pa-0 body-2 blue-grey--text text--darken-3"
          data-testid="confirmationDialog-text-primary"
          v-html="$sanitize(descriptionText, { allowedTags: ['a', 'b', 'br'] })"
        />
        <p
          v-if="description"
          class="ma-0 pa-0 mt-2 body-2 blue-grey--text text--darken-3"
          data-testid="confirmationDialog-text-description"
          v-html="$sanitize(description, { allowedTags: ['a', 'b', 'br'] })"
        />
      </v-card-text>

      <v-card-actions class="justify-end ma-0 pa-0">
        <Button
          color="grey"
          plain
          class="me-4"
          :data-testid="cancelTestID"
          :disabled="isLoading"
          :text="confirmCancelText"
          @click="$emit('cancel')"
        />
        <Button
          plain
          :color="confirmButtonColor"
          :data-testid="confirmTestID"
          :loading="isLoading"
          :disabled="isLoading"
          :text="confirmButtonText"
          @click="$emit('confirm')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Button from '@/components/UI/Button'
export default {
  name: 'ConfirmationModal',

  components: {
    Button,
  },

  props: {
    title: String,
    text: String,
    description: String,
    show: Boolean,
    isLoading: Boolean,
    confirmText: String,
    cancelText: String,
    confirmColor: String,
    maxWidth: Number,
    modalTestID: {
      type: String,
      default: 'confirm-dialog',
    },
    confirmTestID: {
      type: String,
      default: 'confirmationDialog-button-confirm',
    },
    cancelTestID: {
      type: String,
      default: 'confirmationDialog-button-cancel',
    },
    persistent: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    confirmButtonColor() {
      return this.confirmColor ?? 'primary'
    },

    titleText() {
      return this.title ?? this.$t('common.attention')
    },

    descriptionText() {
      return this.text ?? this.$t('common.button.confirm_default_description')
    },

    confirmCancelText() {
      return this.cancelText ?? this.$t('common.button.cancel')
    },

    confirmButtonText() {
      return this.confirmText ?? this.$t('common.button.ok')
    },
  },
}
</script>
